export const SCHEMA_ERROR_MESSAGE =
  'We couldn’t load the schema for this assistant.';

export const USE_RUN_OPTIONS = (maxRetries?: number) => ({
  refreshInterval: (data) => (!data ? 250 : 0),
  onErrorRetry: (error, _, __, revalidate, { retryCount }) => {
    // Don't give up on 404s - the run might be created soon
    if (error.status === 404) {
      if (maxRetries && retryCount >= maxRetries) return;
      // Retry after our refreshInterval
      setTimeout(() => revalidate({ retryCount }), 250);
    }
  },
});

export const STUDIO_METADATA = (apiUrl: string) => ({
  from_studio: true,
  LANGGRAPH_API_URL: apiUrl,
});

export const STUDIO_HEADERS_LOCAL_STORAGE_KEY = 'ls:studio:connectLocalHeaders';
export const STUDIO_BASE_URL_LOCAL_STORAGE_KEY = 'ls:studio:connectLocalUrl';

export const SUPPORTED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'application/pdf',
];

export const TRACE_LOG_TOP_PADDING = 46;
export const STICKY_HEADER_NODE_HEIGHT = 24;
export const STICK_HEADER_DATA_ROW_HEIGHT = 20;
export const STICKY_HEADER_Z_INDEX_MAX = 8;
